module.exports = __webpack_public_path__ + "static/media/logout.a105f5d1.svg";